/**
 * @generated SignedSource<<12bc9bbe6e807478c79e542ab38660ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteModal_query$data = {
  readonly boardsTeaserByRowId: {
    readonly boardsSectionsItemsByBoardsTeaserId: {
      readonly nodes: ReadonlyArray<{
        readonly boardsSectionByBoardsSectionId: {
          readonly boardByBoardId: {
            readonly id: string;
            readonly rowId: string;
            readonly title: string;
          } | null;
          readonly boardId: string;
        } | null;
      } | null>;
    };
  } | null;
  readonly " $fragmentType": "DeleteModal_query";
};
export type DeleteModal_query$key = {
  readonly " $data"?: DeleteModal_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteModal_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "boardsTeaserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteModal_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rowId",
          "variableName": "boardsTeaserId"
        }
      ],
      "concreteType": "BoardsTeaser",
      "kind": "LinkedField",
      "name": "boardsTeaserByRowId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BoardsSectionsItemsConnection",
          "kind": "LinkedField",
          "name": "boardsSectionsItemsByBoardsTeaserId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BoardsSectionsItem",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BoardsSection",
                  "kind": "LinkedField",
                  "name": "boardsSectionByBoardsSectionId",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "boardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Board",
                      "kind": "LinkedField",
                      "name": "boardByBoardId",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "rowId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5fd89062a23a12330662765434c9bcaa";

export default node;
